// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Date$AppTemplateReasonReact from "../../utilities/Date.bs.js";

import './CommentList.css';
;

function CommentList(Props) {
  var commentList = Props.commentList;
  var renderCommentList = function (commentList) {
    return Belt_Array.map(commentList, (function (comment) {
                  var author = comment.author;
                  var author$1 = author !== undefined ? author : "";
                  var text = comment.text;
                  var text$1 = text !== undefined ? text : "";
                  return React.createElement("div", {
                              key: String(comment.id),
                              className: "comment comment-" + String(comment.id)
                            }, React.createElement("div", {
                                  className: "comment-header"
                                }, React.createElement("div", {
                                      className: "comment-author"
                                    }, author$1), React.createElement("div", {
                                      className: "comment-datetime"
                                    }, Date$AppTemplateReasonReact.fromNow(comment.created_at))), React.createElement("div", {
                                  dangerouslySetInnerHTML: {
                                    __html: text$1
                                  }
                                }), renderCommentList(comment.children));
                }));
  };
  return React.createElement("div", undefined, renderCommentList(commentList));
}

var make = CommentList;

export {
  make ,
  
}
/*  Not a pure module */
